"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1107],{

/***/ 61876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "PH": function() { return /* binding */ createAction; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; }
});

// UNUSED EXPORTS: EnhancerArray, MiddlewareArray, SHOULD_AUTOBATCH, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, autoBatchEnhancer, bindActionCreators, clearAllListeners, combineReducers, compose, createActionCreatorInvariantMiddleware, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAction, isActionCreator, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFluxStandardAction, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, nanoid, original, prepareAutoBatched, removeListener, unwrapResult

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
/* provided dependency */ var process = __webpack_require__(34155);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return redux/* compose */.qC;
    return redux/* compose.apply */.qC.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isAction(action) {
    return isPlainObject(action) && "type" in action;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && hasMatchFunction(action);
}
function isFSA(action) {
    return isAction(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function createActionCreatorInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isActionCreator, isActionCreator2 = _c === void 0 ? isActionCreator : _c;
    return function () { return function (next) { return function (action) {
        if (isActionCreator2(action)) {
            console.warn(getMessage(action.type));
        }
        return next(action);
    }; }; };
}
// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
var EnhancerArray = /** @class */ (function (_super) {
    __extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function () {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (EnhancerArray.bind.apply(EnhancerArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array));
function freezeDraftable(val) {
    return (0,immer_esm/* isDraftable */.o$)(val) ? (0,immer_esm/* default */.ZP)(val, function () {
    }) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    if (checkedObjects === void 0) { checkedObjects = new Set(); }
    var tracked = { value: obj };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function (key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        var result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) {
            return { value: result };
        }
    };
    for (var key in keysToDetect) {
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    if (cache == null ? void 0 : cache.has(value))
        return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function (key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function (ignored) {
                if (ignored instanceof RegExp) {
                    return ignored.test(nestedPath);
                }
                return nestedPath === ignored;
            });
            if (hasMatches) {
                return "continue";
            }
        }
        if (!isSerializable(nestedValue)) {
            return { value: {
                    keyPath: nestedPath,
                    value: nestedValue
                } };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) {
                return { value: foundNestedSerializable };
            }
        }
    };
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object")
            return state_2.value;
    }
    if (cache && isNestedFrozen(value))
        cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value))
        return false;
    for (var _i = 0, _c = Object.values(value); _i < _c.length; _i++) {
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null)
            continue;
        if (!isNestedFrozen(nestedValue))
            return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j, _k = options.disableCache, disableCache = _k === void 0 ? false : _k;
    var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var actionCreatorOptions, serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject(reducer)) {
        rootReducer = (0,redux/* combineReducers */.UY)(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = redux/* applyMiddleware.apply */.md.apply(void 0, finalMiddleware);
    var finalCompose = redux/* compose */.qC;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var defaultEnhancers = new EnhancerArray(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(defaultEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0,redux/* createStore */.MT)(rootReducer, preloadedState, composedEnhancer);
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) {
                throw new Error("`builder.addCase` cannot be called with an empty action type");
            }
            if (type in actionsMap) {
                throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    if (false) {}
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if ((0,immer_esm/* isDraft */.mv)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!(0,immer_esm/* isDraftable */.o$)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return (0,immer_esm/* default */.ZP)(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        if (false) {}
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState3(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = Object.keys(state.entities);
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for (var _i = 0, updates_1 = updates; _i < updates_1.length; _i++) {
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) {
                continue;
            }
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) {
            resortEntities(state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
var createAsyncThunk = (function () {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
            payload: payload,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        }); });
        var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
            payload: void 0,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        }); });
        var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
            payload: payload,
            error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        }); });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function () {
                    },
                    dispatchEvent: function () {
                        return false;
                    },
                    onabort: function () {
                    },
                    removeEventListener: function () {
                    },
                    reason: void 0,
                    throwIfAborted: function () {
                    }
                };
            }
            class_1.prototype.abort = function () {
                if (false) {}
            };
            return class_1;
        }());
        function actionCreator(arg) {
            return function (dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function () {
                    return __async(this, null, function () {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                    if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, conditionResult];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) {
                                        throw {
                                            name: "ConditionError",
                                            message: "Aborted due to condition callback returning false."
                                        };
                                    }
                                    started = true;
                                    abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({
                                        name: "AbortError",
                                        message: abortReason || "Aborted"
                                    }); }); });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                    return [4 /*yield*/, Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function (value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function (value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function (result) {
                                                if (result instanceof RejectWithValue) {
                                                    throw result;
                                                }
                                                if (result instanceof FulfillWithMeta) {
                                                    return fulfilled(result.payload, requestId, arg, result.meta);
                                                }
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])];
                                case 3:
                                    finalAction = _c.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [3 /*break*/, 5];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) {
                                        dispatch(finalAction);
                                    }
                                    return [2 /*return*/, finalAction];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function () {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function () { return createAsyncThunk2; };
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise2, onError) {
    if (onError === void 0) { onError = noop; }
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
    return function () { return abortSignal.removeEventListener("abort", callback); };
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
function raceWithSignal(signal, promise2) {
    var cleanup = noop;
    return new Promise(function (resolve, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function () { return cleanup(); }).then(resolve, reject);
    }).finally(function () {
        cleanup = noop;
    });
}
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise2) {
        return catchRejection(raceWithSignal(signal, promise2).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor, opts) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        if (opts == null ? void 0 : opts.autoJoin) {
            parentBlockingPromises.push(result);
        }
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve, reject) {
                        var stopListening = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                        unsubscribe = function () {
                            stopListening();
                            reject();
                        };
                    });
                    promises = [
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, raceWithSignal(signal, Promise.race(promises))];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, autoJoinPromises, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    autoJoinPromises = [];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 6]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal, autoJoinPromises),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, Promise.allSettled(autoJoinPromises)];
                case 5:
                    _c.sent();
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (!isAction(action)) {
            return next(action);
        }
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function () { return function (payload) {
    var _c;
    return ({
        payload: payload,
        meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
    });
}; };
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
var createQueueWithTimer = function (timeout) {
    return function (notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function (options) {
    if (options === void 0) { options = { type: "raf" }; }
    return function (next) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var store = next.apply(void 0, args);
        var notifying = true;
        var shouldNotifyAtEndOfTick = false;
        var notificationQueued = false;
        var listeners = new Set();
        var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
        var notifyListeners = function () {
            notificationQueued = false;
            if (shouldNotifyAtEndOfTick) {
                shouldNotifyAtEndOfTick = false;
                listeners.forEach(function (l) { return l(); });
            }
        };
        return Object.assign({}, store, {
            subscribe: function (listener2) {
                var wrappedListener = function () { return notifying && listener2(); };
                var unsubscribe = store.subscribe(wrappedListener);
                listeners.add(listener2);
                return function () {
                    unsubscribe();
                    listeners.delete(listener2);
                };
            },
            dispatch: function (action) {
                var _a;
                try {
                    notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                    shouldNotifyAtEndOfTick = !notifying;
                    if (shouldNotifyAtEndOfTick) {
                        if (!notificationQueued) {
                            notificationQueued = true;
                            queueCallback(notifyListeners);
                        }
                    }
                    return store.dispatch(action);
                }
                finally {
                    notifying = true;
                }
            }
        });
    }; };
};
// src/index.ts
(0,immer_esm/* enableES5 */.pV)();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 36661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fv": function() { return /* binding */ singleton; }
/* harmony export */ });
/* unused harmony exports ChatboxColors, ChatboxPosition, CrispClass, EventsColors */
var CrispMessage = /** @class */ (function () {
    function CrispMessage(crisp) {
        this.parent = crisp;
    }
    CrispMessage.prototype.send = function (type, content) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:send", [type, content]]);
    };
    CrispMessage.prototype.sendText = function (content) {
        this.send("text", content);
    };
    CrispMessage.prototype.sendFile = function (content) {
        this.send("file", content);
    };
    CrispMessage.prototype.sendAnimation = function (content) {
        this.send("animation", content);
    };
    CrispMessage.prototype.sendAudio = function (content) {
        this.send("audio", content);
    };
    CrispMessage.prototype.show = function (type, content) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:show", [type, content]]);
    };
    CrispMessage.prototype.showText = function (content) {
        this.show("text", content);
    };
    CrispMessage.prototype.showFile = function (content) {
        this.show("file", content);
    };
    CrispMessage.prototype.showAnimation = function (content) {
        this.show("animation", content);
    };
    CrispMessage.prototype.showAudio = function (content) {
        this.show("audio", content);
    };
    CrispMessage.prototype.showPicker = function (content) {
        this.show("picker", content);
    };
    CrispMessage.prototype.showField = function (content) {
        this.show("field", content);
    };
    CrispMessage.prototype.showCarousel = function (content) {
        this.show("carousel", content);
    };
    CrispMessage.prototype.markAsRead = function () {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:read"]);
    };
    CrispMessage.prototype.startThread = function (name) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:thread:start", [name]]);
    };
    CrispMessage.prototype.endThread = function (name) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "message:thread:end", [name]]);
    };
    CrispMessage.prototype.onMessageSent = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:sent"]);
        window.$crisp.push(["on", "message:sent", callback]);
    };
    CrispMessage.prototype.onMessageReceived = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:received"]);
        window.$crisp.push(["on", "message:received", callback]);
    };
    CrispMessage.prototype.onMessageComposeSent = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:compose:sent"]);
        window.$crisp.push(["on", "message:compose:sent", callback]);
    };
    CrispMessage.prototype.onMessageComposeReceived = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "message:compose:received"]);
        window.$crisp.push(["on", "message:compose:received", callback]);
    };
    return CrispMessage;
}());

var CrispUser = /** @class */ (function () {
    function CrispUser(crisp) {
        this.parent = crisp;
    }
    CrispUser.prototype.setNickname = function (nickname) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:nickname", [nickname]]);
    };
    CrispUser.prototype.setEmail = function (email, hmac) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:email", [email, hmac]]);
    };
    CrispUser.prototype.setPhone = function (phone) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:phone", [phone]]);
    };
    CrispUser.prototype.setAvatar = function (avatar) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:avatar", [avatar]]);
    };
    CrispUser.prototype.setCompany = function (name, data) {
        var _payload = {};
        if (data && data.url) {
            _payload.url = data.url;
        }
        if (data && data.description) {
            _payload.description = data.description;
        }
        if (data && data.employment) {
            _payload.employment = [
                data.employment.title
            ];
            if (data.employment.role) {
                _payload.employment.push(data.employment.role);
            }
        }
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["set", "user:company", [name, _payload]]);
    };
    CrispUser.prototype.getEmail = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:email");
    };
    CrispUser.prototype.getPhone = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:phone");
    };
    CrispUser.prototype.getNickname = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:nickname");
    };
    CrispUser.prototype.getAvatar = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:avatar");
    };
    CrispUser.prototype.getCompany = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("user:company");
    };
    CrispUser.prototype.onEmailChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:email:changed"]);
            window.$crisp.push(["on", "user:email:changed", callback]);
        }
    };
    CrispUser.prototype.onPhoneChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:phone:changed"]);
            window.$crisp.push(["on", "user:phone:changed", callback]);
        }
    };
    CrispUser.prototype.onNicknameChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:nickname:changed"]);
            window.$crisp.push(["on", "user:nickname:changed", callback]);
        }
    };
    CrispUser.prototype.onAvatarChanged = function (callback) {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["off", "user:avatar:changed"]);
            window.$crisp.push(["on", "user:avatar:changed", callback]);
        }
    };
    return CrispUser;
}());

var CrispTrigger = /** @class */ (function () {
    function CrispTrigger(crisp) {
        this.parent = crisp;
    }
    CrispTrigger.prototype.run = function (name) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "trigger:run", [name]]);
    };
    return CrispTrigger;
}());

var EventsColors;
(function (EventsColors) {
    EventsColors["Red"] = "red";
    EventsColors["Orange"] = "orange";
    EventsColors["Yellow"] = "yellow";
    EventsColors["Green"] = "green";
    EventsColors["Blue"] = "blue";
    EventsColors["Purple"] = "purple";
    EventsColors["Pink"] = "pink";
    EventsColors["Brown"] = "brown";
    EventsColors["Grey"] = "grey";
    EventsColors["Black"] = "black";
})(EventsColors || (EventsColors = {}));
var CrispSession = /** @class */ (function () {
    function CrispSession(crisp) {
        this.parent = crisp;
    }
    CrispSession.prototype.reset = function (reload) {
        if (reload === void 0) { reload = false; }
        if (this.parent.isCrispInjected()) {
            window.$crisp.do("session:reset", [reload]);
        }
    };
    CrispSession.prototype.setSegments = function (segments, overwrite) {
        this.parent.createSingletonIfNecessary();
        $crisp.push(["set", "session:segments", [segments, overwrite]]);
    };
    CrispSession.prototype.setData = function (data) {
        var _this = this;
        var _payload = [];
        Object.entries(data).forEach(function (item) {
            if (_this.isValidDataValue(item[0])) {
                _payload.push([item[0], item[1]]);
            }
        });
        this.parent.createSingletonIfNecessary();
        $crisp.push(["set", "session:data", [_payload]]);
    };
    CrispSession.prototype.pushEvent = function (name, data, color) {
        if (data === void 0) { data = {}; }
        if (color === void 0) { color = EventsColors.Blue; }
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["set", "session:event", [[[name, data, color]]]]);
        }
    };
    CrispSession.prototype.getData = function (key) {
        if (!this.parent.isCrispInjected()) {
            return undefined;
        }
        return window.$crisp.get("session:data", key);
    };
    CrispSession.prototype.getIdentifier = function () {
        if (!this.parent.isCrispInjected()) {
            return null;
        }
        return window.$crisp.get("session:identifier");
    };
    CrispSession.prototype.onLoaded = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "session:loaded"]);
        window.$crisp.push(["on", "session:loaded", callback]);
    };
    CrispSession.prototype.isValidDataValue = function (value) {
        return (typeof value === "string" ||
            typeof value === "number" ||
            typeof value === "boolean");
    };
    return CrispSession;
}());

var CrispChat = /** @class */ (function () {
    function CrispChat(crisp) {
        this.parent = crisp;
    }
    CrispChat.prototype.show = function () {
        this.parent.autoInjectIfNecessary();
        window.$crisp.push(["do", "chat:show"]);
    };
    CrispChat.prototype.hide = function () {
        this.parent.autoInjectIfNecessary();
        window.$crisp.push(["do", "chat:hide"]);
    };
    CrispChat.prototype.open = function () {
        this.parent.autoInjectIfNecessary();
        window.$crisp.push(["do", "chat:open"]);
    };
    CrispChat.prototype.close = function () {
        if (this.parent.isCrispInjected()) {
            window.$crisp.push(["do", "chat:close"]);
        }
    };
    CrispChat.prototype.setHelpdeskView = function () {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "helpdesk:search"]);
    };
    CrispChat.prototype.openHelpdeskArticle = function (locale, slug, title, category) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "helpdesk:article:open", [locale, slug, title, category]]);
    };
    CrispChat.prototype.queryHelpdesk = function (query) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["do", "helpdesk:query", [query]]);
    };
    CrispChat.prototype.unreadCount = function () {
        if (!this.parent.isCrispInjected()) {
            return 0;
        }
        return window.$crisp.get("chat:unread:count");
    };
    CrispChat.prototype.isChatOpened = function () {
        if (!this.parent.isCrispInjected()) {
            return false;
        }
        return window.$crisp.is("chat:opened");
    };
    CrispChat.prototype.isVisible = function () {
        if (!this.parent.isCrispInjected()) {
            return false;
        }
        return window.$crisp.is("chat:visible");
    };
    CrispChat.prototype.onChatInitiated = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "chat:initiated"]);
        window.$crisp.push(["on", "chat:initiated", callback]);
    };
    CrispChat.prototype.onChatOpened = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "chat:opened"]);
        window.$crisp.push(["on", "chat:opened", callback]);
    };
    CrispChat.prototype.onChatClosed = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "chat:closed"]);
        window.$crisp.push(["on", "chat:closed", callback]);
    };
    CrispChat.prototype.onHelpdeskQueried = function (callback) {
        this.parent.createSingletonIfNecessary();
        window.$crisp.push(["off", "helpdesk:queried"]);
        window.$crisp.push(["on", "helpdesk:queried", callback]);
    };
    return CrispChat;
}());

var ChatboxColors;
(function (ChatboxColors) {
    ChatboxColors["Default"] = "default";
    ChatboxColors["Amber"] = "amber";
    ChatboxColors["Black"] = "black";
    ChatboxColors["Blue"] = "blue";
    ChatboxColors["BlueGrey"] = "blue_grey";
    ChatboxColors["LightBlue"] = "light_blue";
    ChatboxColors["Brown"] = "brown";
    ChatboxColors["Cyan"] = "cyan";
    ChatboxColors["Green"] = "green";
    ChatboxColors["LightGreen"] = "light_green";
    ChatboxColors["Grey"] = "grey";
    ChatboxColors["Indigo"] = "indigo";
    ChatboxColors["Orange"] = "orange";
    ChatboxColors["DeepOrange"] = "deep_orange";
    ChatboxColors["Pink"] = "pink";
    ChatboxColors["Purple"] = "purple";
    ChatboxColors["DeepPurple"] = "deep_purple";
    ChatboxColors["Red"] = "red";
    ChatboxColors["Teal"] = "teal";
})(ChatboxColors || (ChatboxColors = {}));
var ChatboxPosition;
(function (ChatboxPosition) {
    ChatboxPosition["Left"] = "left";
    ChatboxPosition["Right"] = "right";
})(ChatboxPosition || (ChatboxPosition = {}));
var Crisp = /** @class */ (function () {
    function Crisp() {
        // Options
        this.clientUrl = "https://client.crisp.chat/l.js";
        this.websiteId = "";
        this.autoload = true;
        // States
        this.injected = false;
        this.chat = new CrispChat(this);
        this.session = new CrispSession(this);
        this.user = new CrispUser(this);
        this.message = new CrispMessage(this);
        this.trigger = new CrispTrigger(this);
    }
    Crisp.prototype.configure = function (websiteId, options) {
        if (options === void 0) { options = {}; }
        this.websiteId = websiteId;
        this.tokenId = options.tokenId;
        this.locale = options.locale;
        this.sessionMerge = options.sessionMerge;
        this.cookieDomain = options.cookieDomain;
        this.cookieExpire = options.cookieExpire;
        this.lockFullview = options.lockFullview;
        this.lockMaximized = options.lockMaximized;
        this.safeMode = options.safeMode;
        if (options.clientUrl !== undefined) {
            this.clientUrl = options.clientUrl;
        }
        if (options.autoload !== undefined) {
            this.autoload = options.autoload;
        }
        // Autoload Crisp if option is enabled
        if (this.autoload) {
            this.load();
        }
    };
    Crisp.prototype.load = function () {
        var _head = document.getElementsByTagName("head");
        this.createSingletonIfNecessary();
        // Prevents from loading Crisp twice
        if (this.isCrispInjected() === true) {
            return;
        }
        if (!this.websiteId) {
            throw new Error("websiteId must be set before loading Crisp");
        }
        window.CRISP_WEBSITE_ID = this.websiteId;
        window.CRISP_RUNTIME_CONFIG = {};
        if (this.tokenId) {
            window.CRISP_TOKEN_ID = this.tokenId;
        }
        if (this.sessionMerge) {
            window.CRISP_RUNTIME_CONFIG.session_merge = true;
        }
        if (this.locale) {
            window.CRISP_RUNTIME_CONFIG.locale = this.locale;
        }
        if (this.lockFullview) {
            window.CRISP_RUNTIME_CONFIG.lock_full_view = true;
        }
        if (this.lockMaximized) {
            window.CRISP_RUNTIME_CONFIG.lock_maximized = true;
        }
        if (this.cookieDomain) {
            window.CRISP_COOKIE_DOMAIN = this.cookieDomain;
        }
        if (this.cookieExpire) {
            window.CRISP_COOKIE_EXPIRE = this.cookieExpire;
        }
        if (!_head || !_head[0]) {
            return this.deferredLoading();
        }
        if (this.safeMode === true) {
            this.setSafeMode(true);
        }
        var _script = document.createElement("script");
        _script.src = this.clientUrl;
        _script.async = true;
        _head[0].appendChild(_script);
        this.injected = true;
    };
    Crisp.prototype.setTokenId = function (tokenId) {
        this.tokenId = tokenId;
        // Refresh injected token?
        if (this.isCrispInjected() === true) {
            if (tokenId) {
                window.CRISP_TOKEN_ID = tokenId;
            }
            else {
                delete window.CRISP_TOKEN_ID;
            }
        }
    };
    Crisp.prototype.setZIndex = function (zIndex) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "container:index", [zIndex]]);
    };
    Crisp.prototype.setColorTheme = function (color) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "color:theme", [color]]);
    };
    Crisp.prototype.setHideOnAway = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "hide:on:away", [enabled]]);
    };
    Crisp.prototype.setHideOnMobile = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "hide:on:mobile", [enabled]]);
    };
    Crisp.prototype.setPosition = function (position) {
        this.createSingletonIfNecessary();
        $crisp.push(["config", "position:reverse", [position === ChatboxPosition.Left]]);
    };
    Crisp.prototype.setAvailabilityTooltip = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "availability:tooltip", [enabled]]);
    };
    Crisp.prototype.setVacationMode = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "hide:vacation", [enabled]]);
    };
    Crisp.prototype.setSafeMode = function (safe) {
        if (safe === void 0) { safe = true; }
        this.createSingletonIfNecessary();
        window.$crisp.push(["safe", safe]);
    };
    Crisp.prototype.muteSound = function (mute) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "sound:mute", [mute]]);
    };
    Crisp.prototype.toggleOperatorCount = function (enabled) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["config", "show:operator:count", [enabled]]);
    };
    Crisp.prototype.onWebsiteAvailabilityChanged = function (callback) {
        this.createSingletonIfNecessary();
        window.$crisp.push(["off", "website:availability:changed"]);
        window.$crisp.push(["on", "website:availability:changed", callback]);
    };
    Crisp.prototype.createSingletonIfNecessary = function () {
        // Assigns $crisp singleton
        if (window.$crisp === undefined) {
            window.$crisp = [];
        }
    };
    Crisp.prototype.autoInjectIfNecessary = function () {
        if (!this.isCrispInjected()) {
            this.load();
        }
    };
    Crisp.prototype.isCrispInjected = function () {
        // Check if Crisp was injected (either from the Web SDK, or from another \
        //   source)
        if (this.injected === true || (window.$crisp && window.$crisp.is)) {
            return true;
        }
        return false;
    };
    Crisp.prototype.deferredLoading = function () {
        var _this = this;
        document.addEventListener("DOMContentLoaded", function () {
            _this.load();
        });
    };
    return Crisp;
}());
var singleton = new Crisp();


//# sourceMappingURL=crisp.esm.js.map


/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: this.store },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 62286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(76489);
var setCookieParser = __webpack_require__(69328);
var utils_1 = __webpack_require__(51022);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51022:
/***/ (function(__unused_webpack_module, exports) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 2497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "dC": function() { return /* reexport */ react_dom.unstable_batchedUpdates; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, connect, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var Context_ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription_Subscription = /*#__PURE__*/function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = new Subscription_Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || Context_ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = (/* unused pure expression or super */ null && ([]));
var NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null]));

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced_connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose(props, ["reactReduxForwardedRef"]);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new Subscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo(function () {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? defaultSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/(/* unused pure expression or super */ null && (createConnect())));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(Context_ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useStore = context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return new Subscription_Subscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState();

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = Context_ReactReduxContext;
  }

  var useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js










setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 68697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ./node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ./node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ }),

/***/ 69328:
/***/ (function(module) {



var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 88244:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Channel; }
/* harmony export */ });
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7722);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/base.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.wssocial.entity.message.v1.Channel
 */
const Channel = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.Channel",
  () => [
    { no: 1, name: "chatroom", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "roomlist", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);



/***/ }),

/***/ 65064:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gn": function() { return /* binding */ received_pb_ReceivedMessage; }
});

// UNUSED EXPORTS: Body, Error, Ping, Ping_PingStatus, ReceivedEvent, ReceivedEvent_Data, ReceivedEvent_Type, ReceivedMessage_Type, Subscription, Subscription_Status

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/message/v1/base_pb.js
var base_pb = __webpack_require__(88244);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/text_mask_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/text_mask.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.chat.entity.v2.TextFormat
 */
const TextFormat = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.TextFormat",
  [
    {no: 0, name: "TEXT_FORMAT_REGULAR", localName: "REGULAR"},
    {no: 1, name: "TEXT_FORMAT_BOLD", localName: "BOLD"},
    {no: 2, name: "TEXT_FORMAT_ITALIC", localName: "ITALIC"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MaskedText
 */
const MaskedText = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MaskedText",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TextMaskValue} },
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextMaskValue
 */
const TextMaskValue = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.TextMaskValue",
  () => [
    { no: 1, name: "format", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TextFormat) },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "link", kind: "message", T: TextLink },
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextLink
 */
const TextLink = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.TextLink",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TextLink_LinkType) },
    { no: 2, name: "ref", kind: "message", T: TextLink_LinkRef },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.TextLink.LinkType
 */
const TextLink_LinkType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.TextLink.LinkType",
  [
    {no: 0, name: "LINK_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINK_TYPE_USER", localName: "USER"},
    {no: 2, name: "LINK_TYPE_SYMBOL", localName: "SYMBOL"},
    {no: 3, name: "LINK_TYPE_KNOWN_URL", localName: "KNOWN_URL"},
    {no: 4, name: "LINK_TYPE_URL", localName: "URL"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.TextLink.LinkRef
 */
const TextLink_LinkRef = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.TextLink.LinkRef",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "val" },
  ],
  {localName: "TextLink_LinkRef"},
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMaskedText
 */
const PlaceholderMaskedText = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PlaceholderMaskedText",
  () => [
    { no: 1, name: "masked_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masks", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: PlaceholderMask} },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMask
 */
const PlaceholderMask = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PlaceholderMask",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlaceholderMask_PlaceholderType) },
    { no: 2, name: "placeholder", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reference", kind: "message", T: PlaceholderMask_Reference },
  ],
);

/**
 * used to determine "username" and "to be" based on the user's point of view
 * First person point of view example: "You are an admin now"
 * Third person point of view example: "StockbitUser is an admin now"
 *
 * @generated from enum social.chat.entity.v2.PlaceholderMask.PlaceholderType
 */
const PlaceholderMask_PlaceholderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.PlaceholderMask.PlaceholderType",
  [
    {no: 0, name: "PLACEHOLDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLACEHOLDER_TYPE_USERNAME", localName: "USERNAME"},
    {no: 2, name: "PLACEHOLDER_TYPE_TO_BE", localName: "TO_BE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.PlaceholderMask.Reference
 */
const PlaceholderMask_Reference = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PlaceholderMask.Reference",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "PlaceholderMask_Reference"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/verified_badge/enum/v1/verified_status_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/verified_badge/enum/v1/verified_status.proto (package social.verified_badge.enum.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.verified_badge.enum.v1.VerifiedStatus
 */
const verified_status_pb_VerifiedStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.verified_badge.enum.v1.VerifiedStatus",
  [
    {no: 0, name: "VERIFIED_STATUS_UNVERIFIED", localName: "UNVERIFIED"},
    {no: 1, name: "VERIFIED_STATUS_IDENTITY", localName: "IDENTITY"},
    {no: 2, name: "VERIFIED_STATUS_COMMUNITY", localName: "COMMUNITY"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/room_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/room.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from enum social.chat.entity.v2.RoomType
 */
const RoomType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.RoomType",
  [
    {no: 0, name: "ROOM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROOM_TYPE_PERSONAL", localName: "PERSONAL"},
    {no: 2, name: "ROOM_TYPE_GROUP", localName: "GROUP"},
    {no: 3, name: "ROOM_TYPE_BROADCAST", localName: "BROADCAST"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.RoomState
 */
const room_pb_RoomState = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.RoomState",
  [
    {no: 0, name: "ROOM_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ROOM_STATE_ACCEPTED", localName: "ACCEPTED"},
    {no: 2, name: "ROOM_STATE_INVITED", localName: "INVITED"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomInfo
 */
const RoomInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomInfo",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shortened_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.BaseRoom
 */
const BaseRoom = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.BaseRoom",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(RoomType) },
    { no: 3, name: "info", kind: "message", T: RoomInfo },
    { no: 4, name: "state", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(room_pb_RoomState) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.Room
 */
const Room = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.Room",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(RoomType) },
    { no: 3, name: "info", kind: "message", T: RoomInfo },
    { no: 4, name: "attributes", kind: "message", T: RoomAttribute },
    { no: 5, name: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "last_message", kind: "message", T: LastMessage },
    { no: 7, name: "status", kind: "message", T: RoomStatus },
    { no: 8, name: "state", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(room_pb_RoomState) },
    { no: 9, name: "unread_message", kind: "message", T: UnreadMessage },
  ],
);

/**
 * @generated from message social.chat.entity.v2.UnreadMessage
 */
const UnreadMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.UnreadMessage",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "last_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.LastMessage
 */
const LastMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.LastMessage",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sender_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(LastMessage_AttachmentType) },
    { no: 4, name: "created_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 5, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "placeholder_mask", kind: "message", T: PlaceholderMaskedText },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.LastMessage.AttachmentType
 */
const LastMessage_AttachmentType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.LastMessage.AttachmentType",
  [
    {no: 0, name: "ATTACHMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ATTACHMENT_TYPE_PHOTO", localName: "PHOTO"},
    {no: 2, name: "ATTACHMENT_TYPE_GIF", localName: "GIF"},
    {no: 3, name: "ATTACHMENT_TYPE_POST", localName: "POST"},
    {no: 4, name: "ATTACHMENT_TYPE_SHARETRADE", localName: "SHARETRADE"},
    {no: 5, name: "ATTACHMENT_TYPE_PDF", localName: "PDF"},
    {no: 6, name: "ATTACHMENT_TYPE_STICKER", localName: "STICKER"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomStatus
 */
const RoomStatus = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomStatus",
  () => [
    { no: 1, name: "is_muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_mentioned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.RoomAttribute
 */
const RoomAttribute = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.RoomAttribute",
  () => [
    { no: 1, name: "personal", kind: "message", T: PersonalRoomAttribute, oneof: "attr" },
    { no: 2, name: "group", kind: "message", T: GroupRoomAttribute, oneof: "attr" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PersonalRoomAttribute
 */
const PersonalRoomAttribute = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PersonalRoomAttribute",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_deactivated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_blocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "verified_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(verified_status_pb_VerifiedStatus) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.GroupRoomAttribute
 */
const GroupRoomAttribute = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.GroupRoomAttribute",
  () => [
    { no: 1, name: "member_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/data/v1/comment_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/data/v1/comment.proto (package social.stream.data.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.stream.data.v1.CommenterType
 */
const comment_pb_CommenterType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.data.v1.CommenterType",
  [
    {no: 0, name: "COMMENTER_TYPE_EVERYONE", localName: "EVERYONE"},
    {no: 1, name: "COMMENTER_TYPE_FOLLOWING", localName: "FOLLOWING"},
    {no: 2, name: "COMMENTER_TYPE_MENTION", localName: "MENTION"},
    {no: 3, name: "COMMENTER_TYPE_ONLY_YOU", localName: "ONLY_YOU"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/data/v1/image_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/data/v1/image.proto (package social.stream.data.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.stream.data.v1.FrameType
 */
const image_pb_FrameType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.data.v1.FrameType",
  [
    {no: 0, name: "FRAME_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FRAME_TYPE_SQUARE", localName: "SQUARE"},
    {no: 2, name: "FRAME_TYPE_PORTRAIT", localName: "PORTRAIT"},
    {no: 3, name: "FRAME_TYPE_LANDSCAPE", localName: "LANDSCAPE"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/data/v1/spam_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/data/v1/spam.proto (package social.stream.data.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum social.stream.data.v1.SpamStatus
 */
const spam_pb_SpamStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.data.v1.SpamStatus",
  [
    {no: 0, name: "SPAM_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SPAM_STATUS_DETECTED", localName: "DETECTED"},
    {no: 2, name: "SPAM_STATUS_DELETED", localName: "DELETED"},
    {no: 3, name: "SPAM_STATUS_NOT_SPAM", localName: "NOT_SPAM"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/entity/v1/entity_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/entity/v1/entity.proto (package social.stream.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message social.stream.entity.v1.Polling
 */
const Polling = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Polling",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_date", jsonName: "created_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", jsonName: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end_date", jsonName: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "message", T: PollingOptions, repeated: true },
    { no: 8, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "message_expired", jsonName: "message_expired", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "total_voters", jsonName: "total_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "my_vote", jsonName: "my_vote", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.ImageData
 */
const ImageData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.ImageData",
  () => [
    { no: 1, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "frame", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "frame_type", jsonName: "frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.PollingOptions
 */
const PollingOptions = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.PollingOptions",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count_voters", jsonName: "count_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.TargetPrice
 */
const TargetPrice = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.TargetPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "voted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "current_price", jsonName: "current_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "day_left", jsonName: "day_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "agree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "disagree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "hit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.MaskHtml
 */
const MaskHtml = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.MaskHtml",
  () => [
    { no: 1, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attr", kind: "message", T: MaskAttr },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.MaskAttr
 */
const MaskAttr = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.MaskAttr",
  () => [
    { no: 1, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_company", jsonName: "data_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_user", jsonName: "data_user", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_insider", jsonName: "data_insider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.ReplyContent
 */
const ReplyContent = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.ReplyContent",
  () => [
    { no: 1, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 14, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 15, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Analytics
 */
const Analytics = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Analytics",
  () => [
    { no: 1, name: "impression", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "engagement", kind: "message", T: AnalyticsEngagement },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.AnalyticsEngagement
 */
const AnalyticsEngagement = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.AnalyticsEngagement",
  () => [
    { no: 1, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "reply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "share", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "profile_view", jsonName: "profile_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sign_click", jsonName: "sign_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "media_click", jsonName: "media_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Reports
 */
const Reports = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Reports",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Stream
 */
const Stream = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Stream",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "message", T: Timestamp },
    { no: 7, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 8, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 9, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 10, name: "attachments", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "parent_id", jsonName: "parent_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "user", kind: "message", T: User },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.User
 */
const User = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.User",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.ReplyInfo
 */
const entity_pb_ReplyInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.ReplyInfo",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message social.stream.entity.v1.SpamStream
 */
const SpamStream = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.SpamStream",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "post_url", jsonName: "post_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(SpamStatus) },
    { no: 5, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user", kind: "message", T: User },
    { no: 7, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 8, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Pagination
 */
const Pagination = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Pagination",
  () => [
    { no: 1, name: "current_page", jsonName: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_data_in_page", jsonName: "total_data_in_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_data", jsonName: "total_data", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Liker
 */
const entity_pb_Liker = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Liker",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "followed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.FollowingActivity
 */
const entity_pb_FollowingActivity = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.FollowingActivity",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.News
 */
const News = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.News",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_url", jsonName: "source_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", jsonName: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Research
 */
const Research = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Research",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_label", jsonName: "category_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image_url", jsonName: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
  ],
)));

/**
 * @generated from message social.stream.entity.v1.Insider
 */
const Insider = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.entity.v1.Insider",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shareholder", kind: "message", T: Insider_Shareholder },
    { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(Insider_Type) },
    { no: 5, name: "action", kind: "enum", T: proto3.getEnumType(Insider_Action) },
    { no: 6, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "current", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "corp_action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from enum social.stream.entity.v1.Insider.Type
 */
const Insider_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.Insider.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_LOCAL", localName: "LOCAL"},
    {no: 2, name: "TYPE_FOREIGN", localName: "FOREIGN"},
  ],
);

/**
 * @generated from enum social.stream.entity.v1.Insider.Action
 */
const Insider_Action = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.Insider.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_BOUGHT", localName: "BOUGHT"},
    {no: 2, name: "ACTION_SOLD", localName: "SOLD"},
  ],
);

/**
 * @generated from message social.stream.entity.v1.Insider.Shareholder
 */
const Insider_Shareholder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.Insider.Shareholder",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "Insider_Shareholder"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/entity/v1/sharetrade_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/entity/v1/sharetrade.proto (package social.stream.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.stream.entity.v1.ShareTradeInfo
 */
const sharetrade_pb_ShareTradeInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.ShareTradeInfo",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_type", jsonName: "order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_OrderType) },
    { no: 4, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "pnl", kind: "message", T: ShareTradeInfo_PNL },
  ],
);

/**
 * @generated from enum social.stream.entity.v1.ShareTradeInfo.OrderType
 */
const ShareTradeInfo_OrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.ShareTradeInfo.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "ORDER_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from message social.stream.entity.v1.ShareTradeInfo.PNL
 */
const ShareTradeInfo_PNL = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.entity.v1.ShareTradeInfo.PNL",
  () => [
    { no: 1, name: "percentage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_PNL_Type) },
  ],
  {localName: "ShareTradeInfo_PNL"},
);

/**
 * @generated from enum social.stream.entity.v1.ShareTradeInfo.PNL.Type
 */
const ShareTradeInfo_PNL_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.stream.entity.v1.ShareTradeInfo.PNL.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_GAIN", localName: "GAIN"},
    {no: 2, name: "TYPE_LOSS", localName: "LOSS"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/stream/v1/stream_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/v1/stream.proto (package social.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck








/**
 * @generated from message social.stream.v1.GetUploadTokenRequest
 */
const GetUploadTokenRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenRequest",
  () => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenResponse
 */
const GetUploadTokenResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: DataUploadTokenResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.DataUploadTokenResponse
 */
const DataUploadTokenResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DataUploadTokenResponse",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "aws_access_key_id", jsonName: "aws_access_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "success_action_redirect", jsonName: "success_action_redirect", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokensRequest
 */
const GetUploadTokensRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokensRequest",
  () => [
    { no: 1, name: "filenames", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokensResponse
 */
const GetUploadTokensResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokensResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetUploadTokenData },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenData
 */
const GetUploadTokenData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenData",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tokens", kind: "message", T: GetUploadTokenInfo, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenInfo
 */
const GetUploadTokenInfo = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenInfo",
  () => [
    { no: 1, name: "fields", kind: "message", T: GetUploadTokenInfo_Fields, repeated: true },
    { no: 2, name: "view_url", jsonName: "view_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUploadTokenInfo.Fields
 */
const GetUploadTokenInfo_Fields = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.GetUploadTokenInfo.Fields",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "GetUploadTokenInfo_Fields"},
);

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessRequest
 */
const ProcessUploadSuccessRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessRequest",
  () => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessResponse
 */
const ProcessUploadSuccessResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: ProcessUploadSuccessData },
  ],
)));

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessData
 */
const ProcessUploadSuccessData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessData",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url_bit", jsonName: "url_bit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.WriteStreamRequest
 */
const WriteStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.WriteStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target_symbol", jsonName: "target_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "target_duration", jsonName: "target_duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "polling_end", jsonName: "polling_end", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "polling_options", jsonName: "polling_options", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "polling_pin", jsonName: "polling_pin", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "share_portfolio", jsonName: "share_portfolio", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.WriteStreamResponse
 */
const WriteStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.WriteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.ReplyStreamResponse
 */
const ReplyStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReplyStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveNewsStreamResponse
 */
const SaveNewsStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveNewsStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveInsiderStreamResponse
 */
const SaveInsiderStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveInsiderStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveEmitenReportStreamResponse
 */
const SaveEmitenReportStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveEmitenReportStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateStreamResponse
 */
const UpdateStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.LikeStreamResponse
 */
const LikeStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.LikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UnlikeStreamResponse
 */
const UnlikeStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnlikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.DislikeStreamResponse
 */
const DislikeStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DislikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveStreamResponse
 */
const SaveStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UnsaveStreamResponse
 */
const UnsaveStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnsaveStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.ReportStreamResponse
 */
const ReportStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReportStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.FollowStreamResponse
 */
const FollowStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.FollowStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.UnfollowStreamResponse
 */
const UnfollowStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnfollowStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.PinStreamResponse
 */
const PinStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.PinStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.UnpinStreamResponse
 */
const UnpinStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnpinStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.ShareStreamResponse
 */
const ShareStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ShareStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.PostStreamResponse
 */
const PostStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.PostStreamResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "lastid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 26, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "shorten_url", jsonName: "shorten_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: stream_pb_Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "replyto", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "reply_content", jsonName: "reply_content", kind: "message", T: stream_pb_ReplyContent },
    { no: 42, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "target_price", jsonName: "target_price", kind: "message", T: stream_pb_TargetPrice, repeated: true },
    { no: 45, name: "analytics", kind: "message", T: stream_pb_Analytics },
    { no: 46, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 47, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 49, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 51, name: "polling", kind: "message", T: stream_pb_Polling, repeated: true },
    { no: 52, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 53, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 54, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 55, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 56, name: "verified_status", jsonName: "verified_status", kind: "enum", T: proto3.getEnumType(VerifiedStatus) },
  ],
)));

/**
 * @generated from message social.stream.v1.Polling
 */
const stream_pb_Polling = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.Polling",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_date", jsonName: "created_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", jsonName: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end_date", jsonName: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "message", T: stream_pb_PollingOptions, repeated: true },
    { no: 8, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "message_expired", jsonName: "message_expired", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "total_voters", jsonName: "total_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "my_vote", jsonName: "my_vote", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.ImagesData
 */
const ImagesData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.ImagesData",
  () => [
    { no: 1, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "frame", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "frame_type", jsonName: "frame_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(image_pb_FrameType) },
  ],
);

/**
 * @generated from message social.stream.v1.PollingOptions
 */
const stream_pb_PollingOptions = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.PollingOptions",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count_voters", jsonName: "count_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.TargetPrice
 */
const stream_pb_TargetPrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.TargetPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "voted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "current_price", jsonName: "current_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "day_left", jsonName: "day_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "agree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "disagree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "hit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.MaskHtml
 */
const stream_pb_MaskHtml = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.MaskHtml",
  () => [
    { no: 1, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attr", kind: "message", T: stream_pb_MaskAttr },
  ],
);

/**
 * @generated from message social.stream.v1.MaskAttr
 */
const stream_pb_MaskAttr = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.MaskAttr",
  () => [
    { no: 1, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_company", jsonName: "data_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_user", jsonName: "data_user", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_insider", jsonName: "data_insider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyContent
 */
const stream_pb_ReplyContent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.ReplyContent",
  () => [
    { no: 1, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 14, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 15, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(image_pb_FrameType) },
  ],
);

/**
 * @generated from message social.stream.v1.Analytics
 */
const stream_pb_Analytics = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.Analytics",
  () => [
    { no: 1, name: "impression", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "engagement", kind: "message", T: stream_pb_AnalyticsEngagement },
  ],
);

/**
 * @generated from message social.stream.v1.AnalyticsEngagement
 */
const stream_pb_AnalyticsEngagement = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.AnalyticsEngagement",
  () => [
    { no: 1, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "reply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "share", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "profile_view", jsonName: "profile_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sign_click", jsonName: "sign_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "media_click", jsonName: "media_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.Reports
 */
const stream_pb_Reports = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.Reports",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyStreamRequest
 */
const ReplyStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReplyStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "replyto", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveNewsStreamRequest
 */
const SaveNewsStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveNewsStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveEmitenReportStreamRequest
 */
const SaveEmitenReportStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveEmitenReportStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveInsiderStreamRequest
 */
const SaveInsiderStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveInsiderStreamRequest",
  () => [
    { no: 1, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 2, name: "content_mask", jsonName: "content_mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateStreamRequest
 */
const UpdateStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_symbol", jsonName: "target_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "target_duration", jsonName: "target_duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.LikeStreamRequest
 */
const LikeStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.LikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnlikeStreamRequest
 */
const UnlikeStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnlikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DislikeStreamRequest
 */
const DislikeStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DislikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SaveStreamRequest
 */
const SaveStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SaveStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnsaveStreamRequest
 */
const UnsaveStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnsaveStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.PinStreamRequest
 */
const PinStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.PinStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnpinStreamRequest
 */
const UnpinStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnpinStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.ShareStreamRequest
 */
const ShareStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ShareStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "facebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "twitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "stockbit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.ReportStreamRequest
 */
const ReportStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ReportStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.FollowStreamRequest
 */
const FollowStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.FollowStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UnfollowStreamRequest
 */
const UnfollowStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UnfollowStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateCommenterTypeRequest
 */
const UpdateCommenterTypeRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateCommenterTypeRequest",
  () => [
    { no: 1, name: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
)));

/**
 * @generated from message social.stream.v1.UpdateCommenterTypeResponse
 */
const UpdateCommenterTypeResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UpdateCommenterTypeResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamRequest
 * @deprecated
 */
const DeleteStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "send_email", jsonName: "send_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamResponse
 * @deprecated
 */
const DeleteStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamsRequest
 */
const DeleteStreamsRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamsRequest",
  () => [
    { no: 1, name: "user_id", jsonName: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "send_email", jsonName: "send_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteStreamsResponse
 */
const DeleteStreamsResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteStreamsResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UndeleteStreamRequest
 */
const UndeleteStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UndeleteStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UndeleteStreamResponse
 */
const UndeleteStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UndeleteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnStreamRequest
 */
const DeleteOwnStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnStreamRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnStreamResponse
 */
const DeleteOwnStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnCommentRequest
 */
const DeleteOwnCommentRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnCommentRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.DeleteOwnCommentResponse
 */
const DeleteOwnCommentResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.DeleteOwnCommentResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.AddVoteRequest
 */
const AddVoteRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.AddVoteRequest",
  () => [
    { no: 1, name: "tp_id", jsonName: "tp_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "agree", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.AddVoteResponse
 */
const AddVoteResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.AddVoteResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.ManipulateStreamRequest
 */
const ManipulateStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ManipulateStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "dislike", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.ManipulateStreamResponse
 */
const ManipulateStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.ManipulateStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetGenericStreamRequest
 */
const GetGenericStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetGenericStreamRequest",
  () => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "beforetimestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "reporttype", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUserStreamRequest
 */
const GetUserStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUserStreamRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSymbolStreamRequest
 */
const GetSymbolStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSymbolStreamRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "beforelastpost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "reporttype", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetGenericStreamResponse
 */
const GetGenericStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetGenericStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSymbolStreamResponse
 */
const GetSymbolStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSymbolStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetStreamResponse
 */
const GetStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetStreamResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 25, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "polling", kind: "message", T: stream_pb_Polling, repeated: true },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: stream_pb_Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "total_view", jsonName: "total_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "target_price", jsonName: "target_price", kind: "message", T: stream_pb_TargetPrice, repeated: true },
    { no: 43, name: "analytics", kind: "message", T: stream_pb_Analytics },
    { no: 44, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "last_reply_date", jsonName: "last_reply_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 46, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 47, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 49, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "last_reply", jsonName: "last_reply", kind: "message", T: GetStreamResponse },
    { no: 51, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 52, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 53, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 54, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 55, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 56, name: "following_activity", jsonName: "following_activity", kind: "message", T: FollowingActivity },
    { no: 57, name: "sharetrade_info", jsonName: "sharetrade_info", kind: "message", T: ShareTradeInfo },
  ],
)));

/**
 * @generated from message social.stream.v1.GetUserStreamResponse
 */
const GetUserStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetUserStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetTrendingStreamResponse
 */
const GetTrendingStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetTrendingStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetStreamOldResponse
 */
const GetStreamOldResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.stream.v1.GetStreamOldResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 26, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "polling", kind: "message", T: stream_pb_Polling, repeated: true },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: stream_pb_Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "total_view", jsonName: "total_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "replyto", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "reply_content", jsonName: "reply_content", kind: "message", T: stream_pb_ReplyContent },
    { no: 43, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "target_price", jsonName: "target_price", kind: "message", T: stream_pb_TargetPrice, repeated: true },
    { no: 46, name: "analytics", kind: "message", T: stream_pb_Analytics },
    { no: 47, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 49, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 50, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 51, name: "mask_html", jsonName: "mask_html", kind: "message", T: stream_pb_MaskHtml, repeated: true },
    { no: 52, name: "is_verified", jsonName: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 53, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 54, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(image_pb_FrameType) },
    { no: 55, name: "replying_to", jsonName: "replying_to", kind: "message", T: entity_pb_ReplyInfo },
    { no: 56, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(comment_pb_CommenterType) },
    { no: 57, name: "is_unavailable", jsonName: "is_unavailable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 58, name: "following_activity", jsonName: "following_activity", kind: "message", T: entity_pb_FollowingActivity },
    { no: 59, name: "sharetrade_info", jsonName: "sharetrade_info", kind: "message", T: sharetrade_pb_ShareTradeInfo },
    { no: 60, name: "verified_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(verified_status_pb_VerifiedStatus) },
  ],
);

/**
 * @generated from message social.stream.v1.GetSentimentCompanyNewsRequest
 */
const GetSentimentCompanyNewsRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSentimentCompanyNewsRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSentimentCompanyNewsResponse
 */
const GetSentimentCompanyNewsResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSentimentCompanyNewsResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Sentiment },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.Sentiment
 */
const Sentiment = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.Sentiment",
  () => [
    { no: 1, name: "start_value", jsonName: "start_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_value", jsonName: "end_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "periode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetConversationStreamRequest
 */
const GetConversationStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamRequest",
  () => [
    { no: 1, name: "convo_parentid", jsonName: "convo_parentid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "streamid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetConversationStreamResponse
 */
const GetConversationStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetConversationStreamModel },
  ],
)));

/**
 * @generated from message social.stream.v1.GetConversationStreamModel
 */
const GetConversationStreamModel = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamModel",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "next", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "prev", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "parent", kind: "message", T: GetStreamOldResponse },
    { no: 5, name: "replies", kind: "message", T: GetStreamOldResponse, repeated: true },
    { no: 6, name: "since_message", jsonName: "since_message", kind: "message", T: SinceMessage, repeated: true },
    { no: 7, name: "total_replies", jsonName: "total_replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 9, name: "is_commentable", jsonName: "is_commentable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.stream.v1.SinceMessage
 */
const SinceMessage = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.SinceMessage",
  () => [
    { no: 1, name: "streamid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "change", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "pchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "company_name", jsonName: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "latest", kind: "message", T: IfeedPrice },
  ],
)));

/**
 * @generated from message social.stream.v1.IfeedPrice
 */
const IfeedPrice = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.IfeedPrice",
  () => [
    { no: 1, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastprice", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "volume", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "avgvolume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamRequest
 */
const GetMoreConversationStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamResponse
 */
const GetMoreConversationStreamResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetMoreConversationStreamModel },
  ],
)));

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamModel
 */
const GetMoreConversationStreamModel = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamModel",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "replies", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetTrendingStreamRequest
 */
const GetTrendingStreamRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetTrendingStreamRequest",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamUserRequest
 */
const GetPinnedStreamUserRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamUserRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamUserResponse
 */
const GetPinnedStreamUserResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamUserResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamCompanyRequest
 */
const GetPinnedStreamCompanyRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamCompanyRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetPinnedStreamCompanyResponse
 */
const GetPinnedStreamCompanyResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamCompanyResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSingleStreamPostRequest
 */
const GetSingleStreamPostRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSingleStreamPostRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetSingleStreamPostResponse
 */
const GetSingleStreamPostResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetSingleStreamPostResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
)));

/**
 * @generated from message social.stream.v1.GetLikersRequest
 */
const GetLikersRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetLikersRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetLikersResponse
 */
const GetLikersResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetLikersResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetLikersData },
  ],
)));

/**
 * @generated from message social.stream.v1.GetLikersData
 */
const GetLikersData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetLikersData",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "likers", kind: "message", T: Liker, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetAnnouncementRequest
 */
const GetAnnouncementRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementRequest",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.GetAnnouncementResponse
 */
const GetAnnouncementResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetAnnouncementData, repeated: true },
  ],
)));

/**
 * @generated from message social.stream.v1.GetAnnouncementData
 */
const GetAnnouncementData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementData",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "posted_on", jsonName: "posted_on", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "headline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "retrieved_on", jsonName: "retrieved_on", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "company_icon_url", jsonName: "company_icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UntagTopicRequest
 */
const UntagTopicRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UntagTopicRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
)));

/**
 * @generated from message social.stream.v1.UntagTopicResponse
 */
const UntagTopicResponse = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.stream.v1.UntagTopicResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/message_content_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/message_content.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from enum social.chat.entity.v2.SharedContentType
 */
const SharedContentType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.SharedContentType",
  [
    {no: 0, name: "SHARED_CONTENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHARED_CONTENT_TYPE_STREAM", localName: "STREAM"},
    {no: 2, name: "SHARED_CONTENT_TYPE_GROUP_INVITATION", localName: "GROUP_INVITATION"},
    {no: 3, name: "SHARED_CONTENT_TYPE_SHARETRADE", localName: "SHARETRADE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.Attachment
 */
const Attachment = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.Attachment",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentInternal
 */
const SharedContentInternal = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentInternal",
  () => [
    { no: 1, name: "source_type", kind: "enum", T: proto3.getEnumType(SharedContentInternal_SourceType) },
    { no: 2, name: "source_data", kind: "message", T: SharedContentInternal_SourceData },
  ],
)));

/**
 * @generated from enum social.chat.entity.v2.SharedContentInternal.SourceType
 */
const SharedContentInternal_SourceType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.SharedContentInternal.SourceType",
  [
    {no: 0, name: "SOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SOURCE_TYPE_REFERENCE", localName: "REFERENCE"},
    {no: 2, name: "SOURCE_TYPE_PAYLOAD", localName: "PAYLOAD"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentInternal.SourceData
 */
const SharedContentInternal_SourceData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentInternal.SourceData",
  () => [
    { no: 1, name: "reference", kind: "message", T: SharedContent, oneof: "source" },
    { no: 2, name: "payload", kind: "message", T: SharedContentPayload, oneof: "source" },
  ],
  {localName: "SharedContentInternal_SourceData"},
);

/**
 * @generated from message social.chat.entity.v2.SharedContent
 */
const SharedContent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContent",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SharedContentType) },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPayload
 */
const SharedContentPayload = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPayload",
  () => [
    { no: 1, name: "payload", kind: "message", T: SharedContentPayload_Payload },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.SharedContentPayload.Type
 */
const SharedContentPayload_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.SharedContentPayload.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_SHARETRADE", localName: "SHARETRADE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPayload.Payload
 */
const SharedContentPayload_Payload = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPayload.Payload",
  () => [
    { no: 1, name: "sharetrade", kind: "message", T: message_content_pb_ShareTradeInfo, oneof: "data" },
  ],
  {localName: "SharedContentPayload_Payload"},
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPreview
 */
const SharedContentPreview = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPreview",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SharedContentType) },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "preview", kind: "message", T: SharedContentPreview_Preview },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPreview.Preview
 */
const SharedContentPreview_Preview = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.SharedContentPreview.Preview",
  () => [
    { no: 1, name: "stream", kind: "message", T: GetStreamOldResponse, oneof: "data" },
    { no: 2, name: "invitation", kind: "message", T: InvitationContentPreview, oneof: "data" },
    { no: 3, name: "sharetrade", kind: "message", T: message_content_pb_ShareTradeInfo, oneof: "data" },
  ],
  {localName: "SharedContentPreview_Preview"},
);

/**
 * @generated from message social.chat.entity.v2.InvitationContentPreview
 */
const InvitationContentPreview = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.InvitationContentPreview",
  () => [
    { no: 1, name: "invitation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "room_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.ShareTradeInfo
 */
const message_content_pb_ShareTradeInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.ShareTradeInfo",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(message_content_pb_ShareTradeInfo_OrderType) },
    { no: 4, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_OrderStatus) },
    { no: 5, name: "updated_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_UpdatedStatus) },
    { no: 6, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updated_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "order_time", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 10, name: "label", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ShareTradeInfo_Label) },
    { no: 11, name: "is_show_value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "qty", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "updated_qty", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "total_investment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "is_amend_lot", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.OrderType
 */
const message_content_pb_ShareTradeInfo_OrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "ORDER_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.OrderStatus
 */
const ShareTradeInfo_OrderStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "ORDER_STATUS_AMEND", localName: "AMEND"},
    {no: 3, name: "ORDER_STATUS_CANCEL", localName: "CANCEL"},
    {no: 4, name: "ORDER_STATUS_MATCH", localName: "MATCH"},
    {no: 5, name: "ORDER_STATUS_PARTIAL_MATCH", localName: "PARTIAL_MATCH"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.UpdatedStatus
 */
const ShareTradeInfo_UpdatedStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.UpdatedStatus",
  [
    {no: 0, name: "UPDATED_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UPDATED_STATUS_AMENDED", localName: "AMENDED"},
    {no: 2, name: "UPDATED_STATUS_CANCELLED", localName: "CANCELLED"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.Label
 */
const ShareTradeInfo_Label = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.Label",
  [
    {no: 0, name: "LABEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LABEL_DAY_TRADE", localName: "DAY_TRADE"},
    {no: 2, name: "LABEL_SPLIT_ORDER", localName: "SPLIT_ORDER"},
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/attachment_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/attachment.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from enum social.chat.entity.v2.UploadType
 */
const UploadType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.UploadType",
  [
    {no: 0, name: "UPLOAD_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UPLOAD_TYPE_PICTURE", localName: "PICTURE"},
    {no: 2, name: "UPLOAD_TYPE_DOCUMENT", localName: "DOCUMENT"},
    {no: 3, name: "UPLOAD_TYPE_STICKER", localName: "STICKER"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.AttachmentType
 */
const AttachmentType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.AttachmentType",
  [
    {no: 0, name: "ATTACHMENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ATTACHMENT_TYPE_UPLOADED", localName: "UPLOADED"},
    {no: 2, name: "ATTACHMENT_TYPE_SHARED", localName: "SHARED"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.AttachmentMeta
 */
const AttachmentMeta = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.AttachmentMeta",
  () => [
    { no: 1, name: "picture", kind: "message", T: PictureMeta, oneof: "meta" },
    { no: 2, name: "document", kind: "message", T: DocumentMeta, oneof: "meta" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.PictureMeta
 */
const PictureMeta = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.PictureMeta",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * reserve for later
 *
 * @generated from message social.chat.entity.v2.DocumentMeta
 */
const DocumentMeta = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.DocumentMeta",
  [],
);

/**
 * @generated from message social.chat.entity.v2.UploadAttachment
 */
const UploadAttachment = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.UploadAttachment",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(UploadType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "meta", kind: "message", T: AttachmentMeta },
  ],
);

/**
 * @generated from message social.chat.entity.v2.AttachmentV2
 */
const AttachmentV2 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.AttachmentV2",
  () => [
    { no: 1, name: "upload", kind: "message", T: UploadAttachment, oneof: "attachment" },
    { no: 2, name: "shared", kind: "message", T: SharedContentPreview, oneof: "attachment" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.UploadAttachmentParam
 */
const UploadAttachmentParam = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.UploadAttachmentParam",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(UploadType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/member_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/member.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from enum social.chat.entity.v2.MemberRole
 */
const MemberRole = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MemberRole",
  [
    {no: 0, name: "MEMBER_ROLE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MEMBER_ROLE_NORMAL", localName: "NORMAL"},
    {no: 2, name: "MEMBER_ROLE_ADMIN", localName: "ADMIN"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MemberUser
 */
const MemberUser = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MemberUser",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "member_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "verified_status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(verified_status_pb_VerifiedStatus) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.GroupMember
 */
const GroupMember = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.GroupMember",
  () => [
    { no: 1, name: "user", kind: "message", T: MemberUser },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(MemberRole) },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(RoomState) },
    { no: 4, name: "is_interactable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.chat.entity.v2.MemberUserData
 */
const MemberUserData = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.MemberUserData",
  () => [
    { no: 1, name: "member_info", kind: "message", T: MemberUser },
    { no: 2, name: "is_group_member", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
)));

/**
 * @generated from message social.chat.entity.v2.MemberStats
 */
const MemberStats = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.MemberStats",
  () => [
    { no: 1, name: "capacity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "current", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "available", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "active", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));

/**
 * @generated from message social.chat.entity.v2.AdminStats
 */
const AdminStats = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "social.chat.entity.v2.AdminStats",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
)));


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/chat/entity/v2/message_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/message.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck







/**
 * @generated from enum social.chat.entity.v2.MessageBodyType
 */
const MessageBodyType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MessageBodyType",
  [
    {no: 0, name: "MESSAGE_BODY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MESSAGE_BODY_TYPE_CONVERSATION", localName: "CONVERSATION"},
    {no: 2, name: "MESSAGE_BODY_TYPE_EVENT", localName: "EVENT"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.MessageStatus
 */
const MessageStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MessageStatus",
  [
    {no: 0, name: "MESSAGE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MESSAGE_STATUS_SENT", localName: "SENT"},
    {no: 2, name: "MESSAGE_STATUS_READ", localName: "READ"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.CursorDirection
 */
const CursorDirection = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.CursorDirection",
  [
    {no: 0, name: "CURSOR_DIRECTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CURSOR_DIRECTION_IN_FRONT", localName: "IN_FRONT"},
    {no: 2, name: "CURSOR_DIRECTION_BEHIND", localName: "BEHIND"},
    {no: 3, name: "CURSOR_DIRECTION_BETWEEN", localName: "BETWEEN"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.Message
 */
const Message = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.Message",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "body_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(MessageBodyType) },
    { no: 3, name: "body", kind: "message", T: MessageBody },
    { no: 4, name: "created_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageBody
 */
const MessageBody = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageBody",
  () => [
    { no: 1, name: "conversation", kind: "message", T: MessageConversation, oneof: "body" },
    { no: 2, name: "event", kind: "message", T: MessageEvent, oneof: "body" },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageEvent
 */
const MessageEvent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageEvent",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "format", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(TextFormat) },
    { no: 3, name: "placeholder_mask", kind: "message", T: PlaceholderMaskedText },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageConversation
 */
const MessageConversation = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageConversation",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "masked_text", kind: "message", T: MaskedText },
    { no: 3, name: "content", kind: "message", T: MessageContent },
    { no: 4, name: "sender", kind: "message", T: MessageSender },
    { no: 5, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(MessageStatus) },
    { no: 6, name: "flag", kind: "message", T: MessageFlag },
    { no: 7, name: "replied_message", kind: "message", T: Message },
    { no: 8, name: "attachment_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(AttachmentType) },
    { no: 9, name: "attachment", kind: "message", T: AttachmentV2 },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageFlag
 */
const MessageFlag = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageFlag",
  () => [
    { no: 1, name: "is_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_forwarded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_time_displayed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageSender
 */
const MessageSender = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageSender",
  () => [
    { no: 1, name: "user", kind: "message", T: MemberUser },
    { no: 2, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "displayed_as", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(MessageSender_DisplayedAs) },
    { no: 4, name: "is_active_member", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.MessageSender.DisplayedAs
 */
const MessageSender_DisplayedAs = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.chat.entity.v2.MessageSender.DisplayedAs",
  [
    {no: 0, name: "DISPLAYED_AS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DISPLAYED_AS_SENDER", localName: "SENDER"},
    {no: 2, name: "DISPLAYED_AS_RECEIVER", localName: "RECEIVER"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MessageContent
 */
const MessageContent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.chat.entity.v2.MessageContent",
  () => [
    { no: 1, name: "attachment", kind: "message", T: Attachment },
    { no: 2, name: "shared_content", kind: "message", T: SharedContentPreview },
    { no: 3, name: "replied_message", kind: "message", T: Message },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/chat/v1/message_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/chat/v1/message.proto (package social.wssocial.entity.wsevent.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedMessage
 */
const ReceivedMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedMessage",
  () => [
    { no: 1, name: "v1", kind: "message", T: ReceivedMessageV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1
 */
const ReceivedMessageV1 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1",
  () => [
    { no: 1, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "room", kind: "message", T: BaseRoom },
    { no: 3, name: "room_status", kind: "message", T: ReceivedMessageV1_RoomStatus },
    { no: 4, name: "message", kind: "message", T: Message },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1.RoomStatus
 */
const ReceivedMessageV1_RoomStatus = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedMessageV1.RoomStatus",
  () => [
    { no: 1, name: "is_muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_mentioned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReceivedMessageV1_RoomStatus"},
);


// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/chat/v1/typing_indicator_pb.js
var typing_indicator_pb = __webpack_require__(1835);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/wsevent/chat/v1/room_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/chat/v1/room.proto (package social.wssocial.entity.wsevent.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfo
 */
const ReceivedRoomInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfo",
  () => [
    { no: 1, name: "v1", kind: "message", T: ReceivedRoomInfoV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfoV1
 */
const ReceivedRoomInfoV1 = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedRoomInfoV1",
  () => [
    { no: 1, name: "room", kind: "message", T: Room },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/social/wssocial/entity/message/v1/received_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/received.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck







/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedMessage
 */
const received_pb_ReceivedMessage = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedMessage",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ReceivedMessage_Type) },
    { no: 2, name: "body", kind: "message", T: Body },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ReceivedMessage.Type
 */
const ReceivedMessage_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.ReceivedMessage.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_PING", localName: "PING"},
    {no: 2, name: "TYPE_SUBSCRIBE", localName: "SUBSCRIBE"},
    {no: 3, name: "TYPE_UNSUBSCRIBE", localName: "UNSUBSCRIBE"},
    {no: 4, name: "TYPE_BROADCAST", localName: "BROADCAST"},
    {no: 5, name: "TYPE_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Body
 */
const Body = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Body",
  () => [
    { no: 1, name: "ping", kind: "message", T: Ping, oneof: "body" },
    { no: 2, name: "subscription", kind: "message", T: Subscription, oneof: "body" },
    { no: 3, name: "event", kind: "message", T: ReceivedEvent, oneof: "body" },
    { no: 4, name: "error", kind: "message", T: Error, oneof: "body" },
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Ping
 */
const Ping = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Ping",
  () => [
    { no: 1, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Ping_PingStatus) },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.Ping.PingStatus
 */
const Ping_PingStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.Ping.PingStatus",
  [
    {no: 0, name: "PING_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PING_STATUS_OK", localName: "OK"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Subscription
 */
const Subscription = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Subscription",
  () => [
    { no: 1, name: "channel", kind: "message", T: base_pb/* Channel */.$ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Subscription_Status) },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.Subscription.Status
 */
const Subscription_Status = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.Subscription.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_SUBSCRIBED", localName: "SUBSCRIBED"},
    {no: 2, name: "STATUS_UNSUBSCRIBED", localName: "UNSUBSCRIBED"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedEvent
 */
const ReceivedEvent = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ReceivedEvent_Type) },
    { no: 2, name: "data", kind: "message", T: ReceivedEvent_Data },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.ReceivedEvent.Type
 */
const ReceivedEvent_Type = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "social.wssocial.entity.message.v1.ReceivedEvent.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CHAT_MESSAGE", localName: "CHAT_MESSAGE"},
    {no: 2, name: "TYPE_CHAT_TYPING_INDICATOR", localName: "CHAT_TYPING_INDICATOR"},
    {no: 3, name: "TYPE_CHAT_ROOM_INFO", localName: "CHAT_ROOM_INFO"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.ReceivedEvent.Data
 */
const ReceivedEvent_Data = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.ReceivedEvent.Data",
  () => [
    { no: 1, name: "chat_message", kind: "message", T: ReceivedMessage, oneof: "data" },
    { no: 2, name: "chat_typing_indicator", kind: "message", T: typing_indicator_pb/* ReceivedTypingIndicator */.$B, oneof: "data" },
    { no: 3, name: "chat_room_info", kind: "message", T: ReceivedRoomInfo, oneof: "data" },
  ],
  {localName: "ReceivedEvent_Data"},
);

/**
 * @generated from message social.wssocial.entity.message.v1.Error
 */
const Error = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "social.wssocial.entity.message.v1.Error",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);



/***/ }),

/***/ 79278:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uz": function() { return /* binding */ SendMessage; }
/* harmony export */ });
/* unused harmony exports SendMessage_Type, Payload, SendEvent, SendEvent_Type, SendEvent_Data */
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7722);
/* harmony import */ var _base_pb_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88244);
/* harmony import */ var _wsevent_chat_v1_typing_indicator_pb_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1835);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/send.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck





/**
 * @generated from message social.wssocial.entity.message.v1.SendMessage
 */
const SendMessage = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.SendMessage",
  () => [
    { no: 1, name: "type", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.getEnumType */ .w.getEnumType(SendMessage_Type) },
    { no: 2, name: "payload", kind: "message", T: Payload },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.SendMessage.Type
 */
const SendMessage_Type = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.SendMessage.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_PING", localName: "PING"},
    {no: 2, name: "TYPE_SUBSCRIBE", localName: "SUBSCRIBE"},
    {no: 3, name: "TYPE_UNSUBSCRIBE", localName: "UNSUBSCRIBE"},
    {no: 4, name: "TYPE_BROADCAST", localName: "BROADCAST"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Payload
 */
const Payload = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.Payload",
  () => [
    { no: 1, name: "channel", kind: "message", T: _base_pb_js__WEBPACK_IMPORTED_MODULE_2__/* .Channel */ .$, oneof: "payload" },
    { no: 2, name: "event", kind: "message", T: SendEvent, oneof: "payload" },
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.SendEvent
 */
const SendEvent = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.SendEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.getEnumType */ .w.getEnumType(SendEvent_Type) },
    { no: 2, name: "data", kind: "message", T: SendEvent_Data },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.SendEvent.Type
 */
const SendEvent_Type = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.makeEnum */ .w.makeEnum(
  "social.wssocial.entity.message.v1.SendEvent.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CHAT_TYPING_INDICATOR", localName: "CHAT_TYPING_INDICATOR"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.SendEvent.Data
 */
const SendEvent_Data = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_1__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.message.v1.SendEvent.Data",
  () => [
    { no: 1, name: "chat_typing_indicator", kind: "message", T: _wsevent_chat_v1_typing_indicator_pb_js__WEBPACK_IMPORTED_MODULE_0__/* .SendTypingIndicator */ .w0, oneof: "data" },
  ],
  {localName: "SendEvent_Data"},
);



/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ ReceivedTypingIndicator; },
/* harmony export */   "w0": function() { return /* binding */ SendTypingIndicator; }
/* harmony export */ });
/* unused harmony exports ReceivedTypingIndicatorV1, ReceivedTypingIndicatorV1_UserTypingInfo */
/* harmony import */ var _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7722);
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/wsevent/chat/v1/typing_indicator.proto (package social.wssocial.entity.wsevent.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.SendTypingIndicator
 */
const SendTypingIndicator = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.SendTypingIndicator",
  () => [
    { no: 1, name: "room_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "is_typing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicator
 */
const ReceivedTypingIndicator = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicator",
  () => [
    { no: 2, name: "v1", kind: "message", T: ReceivedTypingIndicatorV1 },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1
 */
const ReceivedTypingIndicatorV1 = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1",
  () => [
    { no: 1, name: "room_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "user", kind: "message", T: ReceivedTypingIndicatorV1_UserTypingInfo },
    { no: 3, name: "is_typing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1.UserTypingInfo
 */
const ReceivedTypingIndicatorV1_UserTypingInfo = /*@__PURE__*/ _bufbuild_protobuf__WEBPACK_IMPORTED_MODULE_0__/* .proto3.makeMessageType */ .w.makeMessageType(
  "social.wssocial.entity.wsevent.chat.v1.ReceivedTypingIndicatorV1.UserTypingInfo",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "ReceivedTypingIndicatorV1_UserTypingInfo"},
);



/***/ })

}]);